"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogStreamEventMsgs = getLogStreamEventMsgs;
const client_cloudwatch_logs_1 = require("@aws-sdk/client-cloudwatch-logs");
const logger_1 = require("../logger");
function getLogStreamEventMsgs(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { logGroupName, logStreamName, startFromHead = true } = params;
        const cloudWatchLogsClient = new client_cloudwatch_logs_1.CloudWatchLogsClient();
        try {
            const command = new client_cloudwatch_logs_1.GetLogEventsCommand({
                logGroupName,
                logStreamName,
                startFromHead,
            });
            const response = yield cloudWatchLogsClient.send(command);
            const responseEvents = response.events;
            if (!responseEvents) {
                return [];
            }
            return responseEvents
                .filter((event) => event.message !== undefined)
                .map((event) => { var _a; return (_a = event.message) !== null && _a !== void 0 ? _a : ""; });
        }
        catch (error) {
            logger_1.logger.error("Error reading log stream:", error);
            throw error;
        }
    });
}
